import { jsx } from 'react/jsx-runtime';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled, css } from 'styled-components';

const Container = styled.div.withConfig({
  displayName: "BadgePermissionRole__Container",
  componentId: "sc-c0c3c83e-0"
})([
  `height:19px;padding:0 0.25rem;border-radius:6px;background:`,
  `;color:`,
  `;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:12px;text-transform:uppercase;flex-shrink:0;`,
  ` `,
  ``
], cssVar["color-app-primary-cmp"], cssVar["color-app-primary"], (p) => p.size === "sm" && css([
  `font-size:9px;height:15px;padding:0 3px;`
]), (p) => p.state === "offline" && css([
  `opacity:0.35;`
]));
const sentenceByRoleCurrentUser = {
  viewer: "You can view this [itemType]",
  commenter: "You can comment on this [itemType]",
  editor: "You can edit this [itemType]",
  owner: "You are the owner of this [itemType]"
};
const sentenceByRole = {
  viewer: "Can view this [itemType]",
  commenter: "Can comment on this [itemType]",
  editor: "Can edit this [itemType]",
  owner: "Owner of this [itemType]"
};
const itemDisplayType = {
  resource: "item",
  space: "space",
  folder: "folder"
};
const BadgePermissionRole = ({ role, itemType, tooltipDescriptionForCurrentUser = true, size, state, style, className }) => {
  return /* @__PURE__ */ jsx(Tooltip, {
    label: (tooltipDescriptionForCurrentUser ? sentenceByRoleCurrentUser : sentenceByRole)[role].replace("[itemType]", itemDisplayType[itemType]),
    delay: 0,
    children: /* @__PURE__ */ jsx(Container, {
      size,
      state,
      style,
      className,
      children: role
    })
  });
};

export { BadgePermissionRole };
//# sourceMappingURL=BadgePermissionRole.js.map
